"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("./styled/Icon"));

var Icon = function Icon(_ref) {
  var glyph = _ref.glyph,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["glyph"]);

  if ('id' in glyph) {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], props, /*#__PURE__*/_react["default"].createElement("use", {
      xlinkHref: "#".concat(glyph.id)
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    as: glyph
  }));
};

Icon.propTypes = {
  // @ts-expect-error `typeof PropTypes.elementType` and React.ComponentType are
  // incompatible types
  glyph: _propTypes["default"].oneOfType([_propTypes["default"].elementType, _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired
  })]).isRequired
};
var _default = Icon;
exports["default"] = _default;